query LookupCitySearch($citySearch: String!) {
  lookupCitySearch(citySearch: $citySearch) {
    nodes {
      id
      lookupCity
      countryId
      stateRegionId
    }
  }
}
